import React, { memo } from 'react';
import cn from 'classnames';
import styles from './FilterField.module.scss';

const FilterField = ({
  label,
  active = false,
  required = false,
  children,
  className,
  style,
}) => (
  <div
    className={cn(styles.root, className, {
      [styles.active]: active,
      [styles.required]: required && !active,
    })}
    style={style}
  >
    {label && (
      <div className={styles.label}>
        {label}
        {required && !active && <span className={styles.requiredMark}>*</span>}
        {active && <span className={styles.activeDot} />}
      </div>
    )}
    <div className={styles.control}>{children}</div>
  </div>
);

export default memo(FilterField);
